import React from 'react';

import { Icon } from 'design-system-web';

import { useLabels } from '../../i18n/useLabels';
import type { QuestionTypeIcon } from '../../model/questionTypeCatalog';
import type { ResponseTypeViewModel } from '../../viewmodels/createQuestionRowViewModel';

import styles from './ResponseTypeCell.scss';

type Props = {
  viewModel: ResponseTypeViewModel;
};

const ICON_NAME_BY_QUESTION_TYPE_ICON: Record<QuestionTypeIcon, string> = {
  rating: 'dot-circle',
  choice: 'check-circle',
  checklist: 'tasks',
  text: 'align-left',
  numeric: 'hashtag',
  date: 'calendar-alt',
  list: 'list-ul',
  observation: 'eye',
  unknown: 'question-circle',
};

export function ResponseTypeCell({ viewModel }: Props) {
  const { formatMessage } = useLabels();

  return (
    <div className={styles.responseType}>
      <span className={styles.iconChip}>
        <Icon name={ICON_NAME_BY_QUESTION_TYPE_ICON[viewModel.icon]} />
      </span>
      <span className={styles.name}>{formatMessage(viewModel.label)}</span>
    </div>
  );
}
